import React from "react";
import { Switch, Route } from "react-router-dom";
import home from "../Pages/home";
import port from "../Pages/port";

const Main = () => (
  <main>
    <Switch>
      <Route exact path="/" component={home} />
      <Route path="/Port/:org" component={port} />
    </Switch>
  </main>
);

export default Main;



// WEBPACK FOOTER //
// ./src/Routes/router.js